/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { UserDetailDto } from '../models';
// @ts-ignore
import type { UsersSearchPageResponseDto } from '../models';
/**
 * RestUsersManagementApi - axios parameter creator
 * @export
 */
export const RestUsersManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Zwraca pełne informacje o użytkowniku wraz z rolami i uprawnieniami
         * @summary Pobierz szczegóły użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserById', 'userId', userId)
            const localVarPath = `/api/v1/users-management/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Wyszukiwanie użytkowników z filtrami i paginacją
         * @summary Wyszukaj użytkowników z paginacją
         * @param {string} [search] Fraza wyszukiwania (ID, imię, nazwisko, email, SAP)
         * @param {string} [department] Filtruj po departamencie
         * @param {string} [sapNumber] Filtruj po numerze SAP
         * @param {boolean} [hasCustomRolesOrPermissions] Filtruj użytkowników z modyfikacjami ról/uprawnień
         * @param {number} [page] Numer strony (0-indexed)
         * @param {number} [size] Rozmiar strony
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsers: async (search?: string, department?: string, sapNumber?: string, hasCustomRolesOrPermissions?: boolean, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users-management`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (department !== undefined) {
                localVarQueryParameter['department'] = department;
            }

            if (sapNumber !== undefined) {
                localVarQueryParameter['sapNumber'] = sapNumber;
            }

            if (hasCustomRolesOrPermissions !== undefined) {
                localVarQueryParameter['hasCustomRolesOrPermissions'] = hasCustomRolesOrPermissions;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestUsersManagementApi - functional programming interface
 * @export
 */
export const RestUsersManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestUsersManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Zwraca pełne informacje o użytkowniku wraz z rolami i uprawnieniami
         * @summary Pobierz szczegóły użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserById(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserById(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUsersManagementApi.getUserById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Wyszukiwanie użytkowników z filtrami i paginacją
         * @summary Wyszukaj użytkowników z paginacją
         * @param {string} [search] Fraza wyszukiwania (ID, imię, nazwisko, email, SAP)
         * @param {string} [department] Filtruj po departamencie
         * @param {string} [sapNumber] Filtruj po numerze SAP
         * @param {boolean} [hasCustomRolesOrPermissions] Filtruj użytkowników z modyfikacjami ról/uprawnień
         * @param {number} [page] Numer strony (0-indexed)
         * @param {number} [size] Rozmiar strony
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchUsers(search?: string, department?: string, sapNumber?: string, hasCustomRolesOrPermissions?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersSearchPageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchUsers(search, department, sapNumber, hasCustomRolesOrPermissions, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUsersManagementApi.searchUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestUsersManagementApi - factory interface
 * @export
 */
export const RestUsersManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestUsersManagementApiFp(configuration)
    return {
        /**
         * Zwraca pełne informacje o użytkowniku wraz z rolami i uprawnieniami
         * @summary Pobierz szczegóły użytkownika
         * @param {string} userId ID użytkownika (UUID)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserDetailDto> {
            return localVarFp.getUserById(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Wyszukiwanie użytkowników z filtrami i paginacją
         * @summary Wyszukaj użytkowników z paginacją
         * @param {string} [search] Fraza wyszukiwania (ID, imię, nazwisko, email, SAP)
         * @param {string} [department] Filtruj po departamencie
         * @param {string} [sapNumber] Filtruj po numerze SAP
         * @param {boolean} [hasCustomRolesOrPermissions] Filtruj użytkowników z modyfikacjami ról/uprawnień
         * @param {number} [page] Numer strony (0-indexed)
         * @param {number} [size] Rozmiar strony
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUsers(search?: string, department?: string, sapNumber?: string, hasCustomRolesOrPermissions?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<UsersSearchPageResponseDto> {
            return localVarFp.searchUsers(search, department, sapNumber, hasCustomRolesOrPermissions, page, size, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestUsersManagementApi - interface
 * @export
 * @interface RestUsersManagementApi
 */
export interface RestUsersManagementApiInterface {
    /**
     * Zwraca pełne informacje o użytkowniku wraz z rolami i uprawnieniami
     * @summary Pobierz szczegóły użytkownika
     * @param {string} userId ID użytkownika (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUsersManagementApiInterface
     */
    getUserById(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<UserDetailDto>;

    /**
     * Wyszukiwanie użytkowników z filtrami i paginacją
     * @summary Wyszukaj użytkowników z paginacją
     * @param {string} [search] Fraza wyszukiwania (ID, imię, nazwisko, email, SAP)
     * @param {string} [department] Filtruj po departamencie
     * @param {string} [sapNumber] Filtruj po numerze SAP
     * @param {boolean} [hasCustomRolesOrPermissions] Filtruj użytkowników z modyfikacjami ról/uprawnień
     * @param {number} [page] Numer strony (0-indexed)
     * @param {number} [size] Rozmiar strony
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUsersManagementApiInterface
     */
    searchUsers(search?: string, department?: string, sapNumber?: string, hasCustomRolesOrPermissions?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<UsersSearchPageResponseDto>;

}

/**
 * RestUsersManagementApi - object-oriented interface
 * @export
 * @class RestUsersManagementApi
 * @extends {BaseAPI}
 */
export class RestUsersManagementApi extends BaseAPI implements RestUsersManagementApiInterface {
    /**
     * Zwraca pełne informacje o użytkowniku wraz z rolami i uprawnieniami
     * @summary Pobierz szczegóły użytkownika
     * @param {string} userId ID użytkownika (UUID)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUsersManagementApi
     */
    public getUserById(userId: string, options?: RawAxiosRequestConfig) {
        return RestUsersManagementApiFp(this.configuration).getUserById(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Wyszukiwanie użytkowników z filtrami i paginacją
     * @summary Wyszukaj użytkowników z paginacją
     * @param {string} [search] Fraza wyszukiwania (ID, imię, nazwisko, email, SAP)
     * @param {string} [department] Filtruj po departamencie
     * @param {string} [sapNumber] Filtruj po numerze SAP
     * @param {boolean} [hasCustomRolesOrPermissions] Filtruj użytkowników z modyfikacjami ról/uprawnień
     * @param {number} [page] Numer strony (0-indexed)
     * @param {number} [size] Rozmiar strony
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUsersManagementApi
     */
    public searchUsers(search?: string, department?: string, sapNumber?: string, hasCustomRolesOrPermissions?: boolean, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return RestUsersManagementApiFp(this.configuration).searchUsers(search, department, sapNumber, hasCustomRolesOrPermissions, page, size, options).then((request) => request(this.axios, this.basePath));
    }
}

